module.exports = __webpack_public_path__ + "img/author.3aa536b2.jpeg";